import request from "@/utils/request";

export default (payload, identifier) =>
  request(`quotes/${identifier}/policies`, payload, { method: "POST" });
